<p-button
  [label]="label"
  [raised]="raised"
  [plain]="plain"
  icon="{{ startIcon || endIcon }}"
  loadingIcon="pi pi-spinner pi-spin"
  [severity]="severity"
  [loading]="loading"
  [disabled]="disabled"
  [rounded]="rounded"
  [outlined]="variant === 'outlined'"
  [text]="variant === 'text'"
  (click)="onClick($event)"
  [type]="type"
  [size]="size === 'medium' ? undefined : size"
  [iconPos]="endIcon ? 'right' : 'left'"
  [ariaLabel]="label"
  [styleClass]="getButtonClass()"
/>
